import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "max-w-sm rounded overflow-hidden shadow-lg bg-white cursor-pointer" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "px-6 py-4" }
const _hoisted_4 = { class: "font-bold text-xl mb-2" }
const _hoisted_5 = { class: "text-gray-700 text-base" }
const _hoisted_6 = { class: "text-gray-700 text-base" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "px-6 pt-4 pb-2 flex justify-end" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "inline-block bg-gray-800 rounded-full px-3 py-1 text-sm font-semibold text-white mr-2 mb-2" }, "Voir plus")
], -1)

import { useRouter } from 'vue-router';
  
export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyCard',
  props: {
    company:Object
    },
  setup(__props) {

const props = __props;


  const router = useRouter()

  

  const goToCompany = () => {
    router.push(`/company/${props.company.companyId}`);
  };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex justify-center md:hover:scale-105",
    onClick: goToCompany
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        class: "w-full",
        src: `${props.company.url}`,
        alt: "Sunset in the mountains"
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(props.company.companyName), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(props.company.addressLine1), 1),
        _createElementVNode("p", _hoisted_6, _toDisplayString(props.company.city) + ", " + _toDisplayString(props.company.province), 1)
      ]),
      _hoisted_7
    ])
  ]))
}
}

})